<template lang="pug">
  include Panel.pug
</template>

<script>
import _ from "underscore";
import api from "@/service/api";
import UserPanel from "@/components/UserPanel";

export default {
  name: "Panel",
  components: {
    UserPanel,
  },
  data: function () {
    return {};
  },
  created() {
    const token = this.$store.state.token;
    if (token) {
      // redirect to home
    }
  },
  methods: {},
  watch: {},
};
</script>
